export default {"src":"/_next/static/media/raise-complaint.e7b14d61.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};